import router from '@/router'
import {userService} from '@/services'
export default function guest({ next, to}) {
    const loggedIn = userService.isLoggedIn()
    if (to.name !== 'login' && loggedIn) { //On autorise un invité qui se dirige vers la page guest (mioddeleware)
        //alert('(guest) Vous etes invité, continuer vers '+ to.name +' differernt de login');
        return next();
    } 
    else if(to.name == 'login' && loggedIn) { //On redirige vers le dashboard si un membre connecté essaie d'affiche la page de login
        //alert('(guest) Vous etes connecté from, continuer vers '+ to.name+ ' meme que login');
        router.push({name: 'dashboard' })
    }
    else { //Pour les autres cas on laisse passer
        return next();
    }
}
